import { IBidCommitteeMemberType } from "models/BidCommittee/BidCommitteeMemberStatusModel";
import { BaseService } from "./base.service";

class BidCommitteeMemberTypeServiceInternal extends BaseService {
	getBidCommitteeMemberTypeList = async (): Promise<
		IBidCommitteeMemberType[]
	> =>
		this.callApi<IBidCommitteeMemberType[]>(
			`BidCommitteeMemberType/GetAll`,
			"GET",
			undefined,
			undefined,
			undefined,
			undefined,
			true
		);
}

export const BidCommitteeMemberTypeService =
	new BidCommitteeMemberTypeServiceInternal();
